<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    class="avatar"
    :style="{
      'min-width': width,
      'min-height': height,
      width: width,
      height: height,
    }"
    :class="{ shadow: withShadow }"
  >
    <template v-if="imageURL">
      <img :src="imageURL" alt="Avatar" />
    </template>
    <template v-else>
      <AvatarSVG :width="width" :height="height" />
    </template>
  </div>
</template>

<script setup lang="ts">
import AvatarSVG from "@/svg/Avatar_default.vue";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    width?: string;
    height?: string;
    shadow?: boolean;
    image?: string | null;
  }>(),
  {
    width: "64px",
    height: "64px",
    shadow: false,
    image: null,
  }
);

const withShadow = computed(() => props.shadow);
const imageURL = computed(() => props.image);
</script>

<style lang="scss" scoped>
.avatar {
  border-radius: var(--kw-widget-global-borderradius-shape);
  border: 2px solid white;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;

  &.shadow {
    filter: $kw-teaser-dropshadow;
  }

  svg,
  img {
    background: #d3d3d3;
    width: 100%;
    height: 100%;
    overflow: hidden;
    object-fit: cover;
    object-position: center center;
    align-self: flex-end;
    transform: scale(1.1);
    transition: transform 0.15s ease-in-out;

    &:hover {
      transform: scale(1.1);
      transition: transform 0.15s ease-in-out;
    }

    &:active {
      transform: scale(1.1);
      transition: transform 0.15s ease-in-out;
    }
  }
}
</style>
